<template>
	<div>
		<div :class="{'d-sm-block':viewToggle||!clickToggle,'d-none':viewToggle||!clickToggle}" class="col-md-4 pt-3 centre_sm_none">
			<div class="right_list_content">
				<div class="d-flex justify-content-between border-bottom" style="line-height: 65px;">
					<div class="pl-3">Search result</div>
					<div class=""></div>
					<div class="dropdown pr-3 screen_result">
						<button type="button" class="btn btn_user-defined dropdown-toggle" data-toggle="dropdown">
					      {{this.resultcheck.length}}/10 Selected results
					    </button>
						<div class="dropdown-menu" style="width: 470px;height: auto">
							<h5 class="dropdown-header d-flex justify-content-between d-block">
								<span class="d-block">Selected results</span>
								<div></div>
								<span class="d-block text-primary" @click="emptycheck()" data-stopPropagation="true">
									Clear all results
								</span>
							</h5>
							<div class="dropdown-divider"></div>
							<a class="dropdown-item pl-3" href="#" v-for="(value,key) in pitch">
								<div class="d-flex bd-highlight">
									<div class="p-2 w-100 text-truncate" style="max-width: 400px;" v-html='value.pitchtexts'></div>
									<div class="p-2 flex-shrink-1" v-show="value != ''">
										<i :value="value.pitchids" class="fa fa-window-close text-primary text-right" data-stopPropagation="true" @click="delitself($event,value.pitchids,key)"></i>
									</div>
								</div>
							</a>
							<h5 class="dropdown-footer d-flex d-block pl-3">
								<div class="flex-fill">Export type</div>

								<div class="flex-fill"><button @click="btnActive = 1" class="btn" :class="{'btn-primary':btnActive == 1}" data-stopPropagation="true">WORD</button></div>
								<div class="flex-fill"><button @click="btnActive = 2" class="btn" :class="{'btn-primary':btnActive == 2}" data-stopPropagation="true">PDF</button></div>
							</h5>
							<div class="d-flex pl-3 pr-3">
								<div class="flex-fill p-2"><button class="btn btn-primary w-100" @click.stop="exports()">Export</button></div>
								<div class="flex-fill p-2"><button class="btn btn-outline-dark w-100" @click="sendemail()" data-stopPropagation="true">Send mailbox</button></div>
							</div>
						</div>
					</div>
				</div>
				<form>
					<div class="d-flex flex-wrap right_information_dropdown">

						<!--<div class="text-muted flex-fill col-4 m-0">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.nationsSelected}}</span>
								</li>
								<div class="dropdown-menu nano statenano" style="height: 442px;">

									<div class="nano-content">

										<a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateState(value)" href="javascript:">{{value}}</a>

									</div>
								</div>
							</div>
						</div>-->
						<div class="col-4 m-0 text-muted flex-fill">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.classifysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: 100%;min-height:230px;width: 195px;">

									<div class="nano-content">
										<a class="dropdown-item" v-for="(value, key) in classifys" @click="filtrateClassifys(value)" href="javascript:">{{value}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-4 m-0 text-muted flex-fill">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.industrysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: 442px;width: 300px;">

									<div class="nano-content">
										<a class="dropdown-item" v-for="(value, key) in industrys" @click="filtrateindustry(key,value)" href="javascript:">{{value}}</a>
									</div>

								</div>
							</div>
						</div>
					</div>
				</form>


				<div class="row nano video_breviary m-0 information_list">
					<div class="nano-content" id="home_right_list" style="width:100%;">
						<ul class="list-unstyled">

							<li v-for="value in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

								<!--<img v-if="homeList.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="subImage(homeList.thumb)" />-->
								<!--<div class="media-body">-->
									<!--<span class="text-right float-right my_protocol">-->
										<!--<input type="checkbox"  class="input_agreement_protocol" @click="gainlength($event,homeList.id,homeList.title)" :value="homeList.resourceId" name="resultcheck" v-model="resultcheck">-->
									<!--</span>-->
									<!--<h5>-->
                                        <!--&lt;!&ndash;文章 组图&ndash;&gt;-->
                                        <!--<router-link class="f15 text-dark font-weight-bold" v-if="homeList.modelType =='content' || homeList.modelType =='images'" :to ="{name:'searchresultId',params :{contentid:subContentId(homeList.resourceId)}}" v-html="homeList.title"></router-link>-->
                                        <!--&lt;!&ndash;杂志 视频&ndash;&gt;-->
                                        <!--<a class="f15 text-dark font-weight-bold" v-if="homeList.modelType =='magazine' || homeList.modelType =='video'" :href="homeList.url" v-html="homeList.title"></a>-->

                                        <!--&lt;!&ndash;项目&ndash;&gt;-->

                                        <!--&lt;!&ndash;数据&ndash;&gt;-->
									<!--</h5>-->



									<!--<div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">-->
										<!--<span v-html="homeList.description"></span>-->

									<!--</div>-->

									<!--<div class="clearfix" style="line-height: 22px;">-->
										<!--<div class="float-left">-->
											<!--<span class="border border-primary text-primary f12 p-11" @click="filtrateClassifys(homeList.catName)"><a href="javascript:;">{{ homeList.catName }}</a></span>-->
										<!--</div>-->
										<!--<div class="float-left pr-3 pl-3" v-if="homeList.description">-->
											<!--<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">-->
										<!--</div>-->
										<!--<div class="float-left" v-if="homeList.description">-->
											<!--<span class="f12 text-muted">{{timeDiff(homeList.published)}}</span>-->
										<!--</div>-->
									<!--</div>-->
								<!--</div>-->

                        <!--文章-->
                        <div v-if="value.modelType == 'content'" class="w-100" style="display: contents">
                            <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                            <div class="media-body">
                                <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                                    <i class="fa fa-file-text-o"></i>　</a>-->                        <span class="text-right float-right my_protocol">
										<input type="checkbox"  class="input_agreement_protocol" :value="value.resourceId" v-if="isSite(value.resourceId)" @click="gainlength($event,value.id,value.title)" name="resultcheck" v-model="resultcheck">
                                </span>
                                <h5>
                                    <router-link class="f15 text-dark font-weight-bold" :to ="{name:'searchresultId',params :{contentid:subContentId(value.resourceId)}}" v-html="value.title">
                                    </router-link>
                                </h5>

                                <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted ">
                                    <span>{{value.description}}</span>
                                </div>
                                <div class="clearfix" style="line-height: 22px;">
                                    <div class="float-left">
                                        <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{ value.catName }}</a></span>
                                </div>
                                <div class="float-left pr-3 pl-3">
                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                </div>
                                <div class="float-left">
                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                </div>
                            </div>

                            <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                        </div>
                        </div>
                        <!--组图-->
                        <div v-if="value.modelType == 'images'" class="w-100" style="display: contents">
                            <div class="media-body">
                                <h5>
                                    <router-link  class="f15 text-dark font-weight-bold" :to ="{name:'searchresultId',params :{contentid:subContentId(value.resourceId)}}" v-html="value.title">
                                    </router-link>
                                </h5>
                                <div class="images">
                                    <img v-for="(value, key, index) in subThumb(value.thumb)" :src="value" alt="" />
                                </div>
                                <div class="clearfix" style="line-height: 22px;">

                                    <div class="float-left">
                                        <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{value.catName}}</a></span>
                                </div>
                                <div class="float-left pr-3 pl-3">
                                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                </div>
                                <div class="float-left">
                                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                </div>
                            </div>
                        </div>
                        </div>
                        <!--视频-->
                        <div v-if="value.modelType == 'video'" class="w-100" style="display: contents">
                            <img class="mr-3 img-thumbnail probations_img" :src="value.thumb" />
                            <div class="media-body">
                                <h5>
                                    <i class="fa fa-film mr-2"></i>
                                    <router-link class="f15 text-dark font-weight-bold" :to ="{name:'videoId',params :{id:1,contentid:subContentId(value.resourceId)}}" v-html="value.title"></router-link>
                                </h5>
                                <p class="f13">Duration:　{{formatSeconds(duration(value.description))}}</p>
                                <div class="clearfix" style="line-height: 22px;">
                                    <div class="float-left">
                                        <span class="border border-primary text-primary f12 p-11"><a href="javascript:" @click="filtrateClassifys(value.catName)">{{ value.catName }}</a></span>
                                    </div>
                                    <div class="float-left pr-3 pl-3" v-if="value.published">
                                        <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                                    </div>
                                    <div class="float-left" v-if="value.published">
                                        <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--音频-->
                        <div v-if="value.modelType == 'audio'" class="w-100" style="display: contents">
                        <img class="mr-3 img-thumbnail probations_img" :src="value.thumb" />
                        <div class="media-body">
                            <h5>
                                <a :href="value.url" class="f15 text-dark font-weight-bold" v-html="value.title">
                                </a>

                                <!--<a :href="value.url" target="_blank" class="f15 text-dark font-weight-bold">{{ value.title }}</a>-->
                            </h5>
                            <p class="f13">Duration:　{{formatSeconds(duration(value.description))}}</p>
                            <div class="clearfix" style="line-height: 22px;">
                                <div class="float-left">
                                    <span class="border border-primary text-primary f12 p-11"><a href="javascript:" @click="filtrateClassifys(value.catName)">{{ value.catName }}</a></span>

                            </div>
                            <div class="float-left pr-3 pl-3" v-if="value.published">
                                <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                            </div>
                            <div class="float-left" v-if="value.published">
                                <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                            </div>
                        </div>
                        </div>
                        </div>
                        <!--杂志-->
                        <div v-if="value.modelType == 'magazine' " class="w-100" style="display: contents">

                <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                <div class="media-body">
                    <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                        <i class="fa fa-file-text-o"></i>　</a>-->
                    <h5>
                        <a :href="value.url" class="f15 text-dark font-weight-bold" v-html="value.title">
                        </a>

                        <!--<a :href="value.url" target="_blank" class="f15 text-dark font-weight-bold">{{ value.title }}</a>-->
                    </h5>

                    <div v-if="value.thumb ==''" class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">

                        <span>{{value.description}}</span>

                    </div>
                    <div class="clearfix" style="line-height: 22px;">
                        <div class="float-left">
                            <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{ value.catName }}</a></span>
                    </div>
                    <div class="float-left pr-3 pl-3">
                        <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                    </div>
                    <div class="float-left">
                        <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                    </div>
                </div>

                </div>
                        </div>
                        <!--项目-->
                        <div v-if="value.modelType=='project'" class="w-100" style="display: contents">
                <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" style="padding: 0.25rem;" />
                <div class="media-body">
                    <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat"><i class="fa fa-file-text-o"></i>{{ value.catName }}</a>-->
                    <h5>
                        <router-link :to="{path:'/project', query :{url:value.url}}" tag="a" class="f15 text-dark font-weight-bold" v-html="value.title">
                        </router-link>
                    </h5>
                    <dl class="card-text text-muted pl-3 p-3 pt-0 pb-0">
                        <dt>Investment scale</dt>
                        <dd>{{JSON.parse(value.description).desInvestScale}}</dd>
                        <dt>Industry</dt>
                        <dd>{{JSON.parse(value.description).desIndustry}}</dd>
                        <dt>Region</dt>
                        <dd>{{JSON.parse(value.description).desRegion}}</dd>
                    </dl>
                    <div class="clearfix" style="line-height: 22px;">

                        <div class="float-left">
                            <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{ value.catName }}</a></span>
                    </div>
                    <div class="float-left pr-3 pl-3">
                        <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
                    </div>
                    <div class="float-left">
                        <span class="f12 text-muted">Ending time of investment and financing{{JSON.parse(value.description).desEndTime}}</span>
                    </div>
                </div>
                </div>
                        </div>
                        <!--数据-->
                        <div v-if="value.modelType =='data'" class="w-100 homeDataList">
                <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                    <i class="fa fa-file-text-o"></i>{{ value.catName }}</a>-->
                <h5>
                    <router-link :to="{path:'/datapage', query :{url:value.url}}" tag="a" class="border border-0 f15 text-dark font-weight-bold" v-html="value.title">
                    </router-link>
                </h5>
                <div class="media-body">

                    <line-chart :chartdata="value.description" />
                    <!--<div class="media-foot font-weight-light text-muted mt-2">{{timeDiff(value.published)}}</div>-->
                </div>

                <div class="clearfix" style="line-height: 22px;">

                    <div class="float-left">
                        <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{ value.catName }}</a></span>
                </div>
                <div class="float-left pr-3 pl-3">
                    <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                </div>
                <div class="float-left">
                    <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                </div>
                </div>
                        </div>

                        <!--直播、专题、专栏、活动、链接-->
                        <div v-if="value.modelType == 'live' || value.modelType == 'vote' || value.modelType == 'space' || value.modelType == 'special' || value.modelType == 'activity' || value.modelType == 'link'"  class="w-100" style="display: contents">
                        <img v-if="value.thumb!=''" class="mr-3 img-thumbnail abstract_img" :src="value.thumb" />
                        <div class="media-body">
                        <!--<a href="javascript:;" @click="column" :value="value.catName" class="btn btn-success btn-sm mb-2 customcat">
                        <i class="fa fa-file-text-o"></i>　</a>-->                        <span class="text-right float-right my_protocol">
                                                        <!--<input type="checkbox"  class="input_agreement_protocol" :value="value.resourceId" @click="gainlength($event,value.id,value.title)" name="resultcheck" v-model="resultcheck">-->
                                                </span>
                            <h5>
                                <a :href="value.url" class="f15 text-dark font-weight-bold" v-html="value.title">
                                </a>

                                <!--<a :href="value.url" target="_blank" class="f15 text-dark font-weight-bold">{{ value.title }}</a>-->
                            </h5>

                        <div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted ">
                        <span>{{value.description}}</span>
                        </div>
                        <div class="clearfix" style="line-height: 22px;">
                        <div class="float-left">
                            <span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(value.catName)"><a href="javascript:">{{ value.catName }}</a></span>
                        </div>
                        <div class="float-left pr-3 pl-3">
                        <img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
                        </div>
                        <div class="float-left">
                        <span class="f12 text-muted">{{timeDiff(value.published)}}</span>
                        </div>
                        </div>

                        <!--<span id="times" class="mt-2">{{timeDiff(value.published)}}</span>-->
                        </div>
                        </div>


                        </li>

                        <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
						</ul>
                        <div v-if="endShow" class="w-100">
                            <p class="text-center p-2">loading....</p>
                        </div>
                        <div v-if="!loadShow&&homeLists.length ==0" class="nodata text-center w-100">
                        <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                        <p class="text-center p-2">loading</p>
</div>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" v-if="loadArticle" :class="{'d-sm-block':viewToggle||clickToggle,'d-none':viewToggle||clickToggle}">
            <articles></articles>
		</div>
        <div class="col-md-8 pl-0 mt-3 centre_sm_none" v-if="!loadArticle" :class="{'d-sm-block':viewToggle||clickToggle,'d-none':viewToggle||clickToggle}">
            <div class="nodataImg w-100 h-100">
            <img src="database/images/dataLogo.png" alt="" />
            </div>
        </div>

		<div class="modal fade" id="myemailModal">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Fill in mailbox</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="exampleFormControlInput1">Your mailbox</label>
							<input type="email" class="form-control" v-model="myEmail" placeholder="Please enter your mailbox">
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click.stop="emailExport()" data-dismiss="modal" v-bind:disabled="sendStatus">Send out</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
			<toast></toast>
	</div>
</template>

<script>
	import articles from './ArticleDetails/Article.vue'

	import toast from './toast/Toast'

	// import swiper from './swiper/swiper.min.js'

    import LineChart from './Chart.vue'

	export default({
		name: 'searchresult',
		data: function() {
			return {
				btnActive:1,
				nations: [],
				classifys: [],
				industrys: [],
				homeLists: [],
				nationsSelected: 'Global',
				classifysSelected: 'All time',
				industrysSelected: 'All industries',
                industryID: 0,
				page: 0,
				total_page: 1,
				searchLenght: '',
				resultcheck: [],
				pitch: [

				],
                myEmail:"",//邮箱
                keywords: '',
				token: '',
                viewToggle:true,
                clickToggle:true,
                sendStatus:false,
                loadShow:false,
                endShow:false,
                loadArticle:false
			}
		},
		created: function() {
            this.viewToggle=this.IsPC();
			var self = this;
			//首页左侧列表请求
			var classify = encodeURI(this.$route.params.keyword);

			this.$axios({
				url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/0/0/'+classify+'/0/0/0',
				method: 'get',
				headers: {
					token: this.token
				}
			}).then(data => {
				var homeLists = data.data.results;
				self.token = data.data.token;
				self.homeLists = homeLists;
				self.total_page = data.data.totalPage;
                self.loadShow = false;

                //右侧文章内容
                if (this.$route.params.contentid) {
                    self.loadArticle = true;
                    self.$router.push({
                        name: 'searchresultId',
                        params: {
                            contentid: this.$route.params.contentid
                        }
                    });
                    return;
                }
                if (homeLists[0].modelType == 'content' || homeLists[0].modelType == 'images') {
                    self.loadArticle = true;
                    self.$router.push({
                        name: 'searchresultId',
                        params: {
                            contentid: self.subContentId(homeLists[0].resourceId)
                        }
                    });
                }

			})

			//请求select框
			this.$axios.post('/api/pc/getquery').then(data => {
                self.nations = data.data.data.nation; //国家
                self.industrys = data.data.data.industry; //行业
//                self.classifys = data.data.data.classify; // 分类
                self.classifys = ['Today','Last week','Last month','The last three months'];
			})

            // 更新热词的搜索次数
            this.searchname();
		},

		mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		},
		methods: {
            clickToggles(){
                this.clickToggle=false;
            },
            goback(){
                if(this.viewToggle){
                    // this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
            emailExport(){
                let that=this;
                let contentid=this.resultcheck.map(function (i,elm) {
                    return i.split("_")[1]
                })
                if (contentid.length == 0) {
                    $(".wrap").text('Choose at least one article！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }
                var reg = /^\w+\@+[0-9a-zA-Z]+\.(com|com.cn|edu|hk|cn|net|org)$/;
                if (!that.myEmail || !reg.test(that.myEmail)) {
                    $(".wrap").text('The mailbox format is incorrect！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }

                $(".wrap").html('<p class="text-center"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>');
                $(".wrap").show();
                that.sendStatus = true;
                this.$axios.post('/api/pc/makefile', {
                    contentid:contentid,
                    type:this.btnActive,
                    email:that.myEmail,
                }).then(data => {
                    if (data.data.state) {
                        $(".wrap").text('Send successfully！');
                        $(".wrap").show().delay(1500).hide(100);
                    } else {
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }
                    that.sendStatus = false;
                })
            },
            exports(){
                let contentid=this.resultcheck.map(function (i,elm) {
                    return i.split("_")[1]
                })
                if (contentid.length == 0) {
                    $(".wrap").text('Choose at least one article！');
                    $(".wrap").show().delay(1500).hide(100);
                    return;
                }

                this.$axios.post('/api/pc/makefile', {
                    contentid:contentid,
                    type:this.btnActive,
                }).then(data => {
                    if (data.data.state) {
                        window.location.href = data.data.data;
                    } else {
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }
                })

            },
			subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');

                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
			filtrateState: function(e) { //国家
				let that = this;
				that.nationsSelected = e;

				var column = encodeURI(e); //全部国家
//				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = that.industryID; //全部行业
				if(e == 'Global') {
					column = 0;
				}

                var start = 0;
                var end = 0;
                var tmp = new Date();
                if (that.classifysSelected  == 'Today') {
                    start = (tmp.getTime() - 3600 * 1000 * 24);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'Last week') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 7);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'Last month') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 30);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'The last three months') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 90);
                    end = tmp.getTime()
                } else {

                }
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/'+start+'/'+end+'/'+ encodeURI(this.$route.params.keyword) +'/'+ column + '/0/' + industry,
					method: 'get',
                    headers: {
                        token: that.token
                    }
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateClassifys: function(e) { //分类
				let that = this;
				that.classifysSelected = e;
				var column = encodeURI(that.nationsSelected); //全部国家
//				var classify = encodeURI(e); //全部分类
				var industry = that.industryID; //全部行业
				if(that.nationsSelected == 'Global') {
					column = 0;
				}
                var start = 0;
                var end = 0;
                var tmp = new Date();
				if (e == 'Today') {
                    start = (tmp.getTime() - 3600 * 1000 * 24);
                    end = tmp.getTime()
                } else if (e == 'Last week') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 7);
                    end = tmp.getTime()
                } else if (e == 'Last month') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 30);
                    end = tmp.getTime()
                } else if (e == 'The last three months') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 90);
                    end = tmp.getTime()
                } else {

                }
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/'+start+'/'+end+'/'+ encodeURI(this.$route.params.keyword) +'/'+ column + '/0/' + industry,
					method: 'get',
                    headers: {
                        token: that.token
                    }
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateindustry: function(e, val) { //行业
				let that = this;
				var column = encodeURI(that.nationsSelected); //全部国家
//				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = e; //全部行业
				that.industryID = e;
				that.industrysSelected = val;
				if(that.nationsSelected == 'Global') {
					column = 0;
				}
//				if(that.classifysSelected == '全部分类') {
//					classify = 0;
//				}
                var start = 0;
                var end = 0;
                var tmp = new Date();
                if (that.classifysSelected  == 'Today') {
                    start = (tmp.getTime() - 3600 * 1000 * 24);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'Last week') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 7);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'Last month') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 30);
                    end = tmp.getTime()
                } else if (that.classifysSelected  == 'The last three months') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 90);
                    end = tmp.getTime()
                } else {

                }
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/'+start+'/'+end+'/'+ encodeURI(this.$route.params.keyword) +'/'+ column + '/0/' + industry,
					method: 'get',
                    headers: {
                        token: that.token
                    }
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					if(response) {
						console.log("失败");
					}
				})
			},
			gainlength: function(thes, e, i) {
				let that = this;
				let checked = thes.target.checked;
				if (!checked) {
					// 如果选中 则是删除
					that.pitch.forEach(function(v, k){
						if (v.pitchids == e) {
							that.pitch.splice(k, 1);
						}
					})

				} else {
					// 未选中 则是添加
					var person = {
						pitchids: e,
						pitchtexts: i
					};

					if(that.pitch.length > 9){
						thes.target.checked = false;

					}else{
						that.pitch.push(person);
					}

				}

			},
			emptycheck: function() {
				let that = this;
				that.resultcheck = [];
				that.pitch = []
			},
			sendemail: function() {
				$("#myemailModal").modal();
			},

			//删除本条
			delitself: function(e, index, key) {

				let that = this;
				var reusltID='';
				//that.pitch.splice(key, 1);
                that.pitch.forEach(function(v, k){
                    if (v.pitchids == index) {
                        that.pitch.splice(k, 1);
                    }
                })
                //更新列表勾选
                that.homeLists.forEach(function (elm,i) {
                    if (elm.id == index) {
                        reusltID=elm.resourceId;
                    }
                })
                that.resultcheck.map(function (elm,i) {
                    if (elm == reusltID) {
                        that.resultcheck.splice($.inArray(elm,that.resultcheck),1);
                    }
                })
//				function removeByValue(arr, val) {
//					for(var i = 0; i < arr.length; i++) {
//						if(arr[i] == val) {
//							arr.splice(i, 1);
//							break;
//						}
//					}
//				}

//				var presentId = that.pitch[key].pitchids;
//				var presentTxt = that.pitch[key].pitchtexts;
//				var aa = that.pitch;
//
//				var somearray = that.resultcheck;
//
//				removeByValue(somearray, index);
//
//				removeByValue(presentTxt, index);
//				removeByValue(presentId, index);
//
//				console.log(aa);

			},
			timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

                if(days > 0) {
                    if (days > 7) {
                        var time = new Date(published);
                        var m = time.getMonth()+1;
                        var d = time.getDate();
                        return m + '-' + d;
                    } else {
                        if(days==1){
                            return days + 'day ago';
                        }
                        return days + 'days ago';
                    }
                }

                if(hours > 0) {
                    if(hours==1){
                        return hours + 'hour ago';
                    }
                    return hours + 'hours ago';
                }

                if(minutes > 0) {
                    if(minutes==1){
                        return minutes + 'minute ago';
                    }
                    return minutes + 'minutes ago';
                }
                if (seconds > 0) {
                    if(seconds==1){
                        return  seconds + 'second ago';
                    }
                    return  seconds + 'second ago';
                }
			},

			handleScroll() {
				var industry ;
				var column ;
				var classify ;
				if(this.nationsSelected == 'Global'){
					column = 0;
				} else {
                    column = this.nationsSelected;
                }
                var start = 0;
                var end = 0;
                var tmp = new Date();
                if (this.classifysSelected == 'Today') {
                    start = (tmp.getTime() - 3600 * 1000 * 24);
                    end = tmp.getTime()
                } else if (this.classifysSelected == 'Last week') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 7);
                    end = tmp.getTime()
                } else if (this.classifysSelected == 'Last month') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 30);
                    end = tmp.getTime()
                } else if (this.classifysSelected == 'The last three months') {
                    start = (tmp.getTime() - 3600 * 1000 * 24 * 90);
                    end = tmp.getTime()
                } else {

                }
				if(this.industrysSelected == 'All industries'){
					industry = 0;
				} else {
                    industry = this.industrysSelected;
                }
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				var self = this;
				if(((all - 20) < (top + client)) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
					    this.endShow = true;
						return;
					}
					this.loadShow = true;
					this.$axios({
						url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/'+ this.page + '/0/0/'+start+'/'+end+'/'+ encodeURI(this.$route.params.keyword) +'/'+ column + '/0/' + industry,
						method: 'get',
						headers: {
							token: self.token
						}

					}).then(data => {
						var homeListes = data.data.results;
						JSON.stringify(homeListes);
						self.token = data.data.token;
						var new_homeLists = self.homeLists.concat(homeListes);
						self.homeLists = new_homeLists;
						self.total_page = data.data.totalPage;
						self.loadShow = false;
					}, function(response) {
						if(response) {
							console.log("失败");
						}
					})
				}

			},
            searchname: function() {
                this.$axios.post('/api/pc/enteringkeyword', {name:this.$route.params.keyword}).then(function(res) {

                })
            },
            subImage(thumb) {
                // 处理组图的显示
                var start = thumb.indexOf('|');

                if (start > 0) {
                    var arr = thumb.split('|');
                    return arr[1];
                } else {
                    return thumb;
                }
            },
            duration(duration) {
                // 查找 站点是否存在
                var start = duration.indexOf('|');

                if (start >= 0) {
                    var arr = duration.split('|');
                    return arr[1];
                } else {
                    return duration;
                }

            },
            formatSeconds(value) {
                var secondTime = parseInt(value); // 秒
                var minuteTime = 0; // 分
                if(secondTime > 60) {
                    minuteTime = parseInt(secondTime / 60);
                    secondTime = parseInt(secondTime % 60);
                    return this.PrefixInteger(parseInt(minuteTime), 2) + ':' + this.PrefixInteger(secondTime, 2);
                } else {
                    return "00:" + this.PrefixInteger(parseInt(secondTime), 2);
                }

            },
            PrefixInteger(num, n) {
                return(Array(n).join(0) + num).slice(-n);
            },
            subThumb(thumb) {
                if (thumb) {
                    var thumb_arr = thumb.split('|');
                    return thumb_arr.slice(0, 3);
                } else {
                    return []
                }
            },
            isSite(resourceId) {
                var start = resourceId.indexOf('_');

                if (start >= 0) {
                    var arr = resourceId.split('_');
                    if (arr[0] == '10005') {
                        return true;
                    }
                    return false;
                } else {
                    return false;
                }
            }

		},
        watch: {
            $route: {
                handler: function(val, oldVal) {
                    var self = this;
                    if (this.$route.params.contentid) {
                        self.loadArticle = true;
                        self.$router.push({
                            name: 'searchresultId',
                            params: {
                                contentid: this.$route.params.contentid
                            }
                        });
                        return;
                    }
                    //首页左侧列表请求
                    var classify = encodeURI(this.$route.params.keyword);

                    this.$axios({
                        url: 'https://recommend.imsilkroad.com/recommend/rest/2/0/0/0/0/0/0/'+classify+'/0/0/0',
                        method: 'get',
                        headers: {
                            token: this.token
                        }
                    }).then(data => {
                        var homeLists = data.data.results;
                        self.token = data.data.token;
                        self.homeLists = homeLists;
                        self.total_page = data.data.totalPage;

                        if (homeLists[0].modelType == 'content' || homeLists[0].modelType == 'images') {
                            self.loadArticle = true;
                            self.$router.push({
                                name: 'searchresultId',
                                params: {
                                    contentid:self.subContentId(homeLists[0].resourceId)
                                }
                            });
                        } else {
                            self.loadArticle = false;
                        }

                    })
                },
                deep: true
            }
        },
		components: {
			toast,
			articles,
			// swiper,
            LineChart
		}
	})
</script>

<style scoped type="text/css">
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    .images{
        margin-bottom:15px;
    }
    .images img{
        height:125px;
        max-width: 30%;
        display: inline-block;
        margin-right: 10px;
    }
    .nodataImg{
        text-align: center;
        position:relative;
    }
    .nodataImg img{
        width:300px;
        height:60px;
        margin:auto;
        left:0;
        top:0;
        right:0;bottom:0;
        display:block;
        position:absolute;
    }
</style>
